// src/pages/talleres/editar/utils/tallerUtils.js
import dayjs from 'dayjs';

// Formatear a CLP
export const formatCLP = (value) => {
  if (!value) return '';
  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

// Parsear de CLP
export const parseCLP = (value) => {
  if (!value) return 0;
  return Number(value.replace(/\$\s?|(\.*)/g, ''));
};

// Campos de valores para modalidades de pago
export const CAMPOS_VALORES_EXT = [
  { key: "valorParticular", label: "Valor particular", required: true },
  { key: "valorVecino", label: "Valor vecino", required: false },
  { key: "valorAdultoMayor", label: "Valor adulto mayor", required: false },
  { key: "valorFuncionarios", label: "Valor funcionarios", required: false },
  { key: "matricula", label: "Matrícula", required: false },
];

// Calcular planes permitidos según duración
export const getAllowedPlans = (fechaInicio, fechaFin) => {
  if (!fechaInicio || !fechaFin) {
    return ['mensual', 'trimestral', 'semestral', 'anual'];
  }

  const inicio = dayjs(fechaInicio);
  const fin = dayjs(fechaFin);
  const meses = fin.diff(inicio, 'month', true);

  const planes = [];
  
  if (meses >= 1) planes.push('mensual');
  if (meses >= 3) planes.push('trimestral');
  if (meses >= 6) planes.push('semestral');
  if (meses >= 12) planes.push('anual');

  // Si no hay planes válidos, permitir al menos mensual
  return planes.length > 0 ? planes : ['mensual'];
};
